import { render } from "./FertilizerList.vue?vue&type=template&id=ccda4f8c&ts=true"
import script from "./FertilizerList.vue?vue&type=script&lang=ts"
export * from "./FertilizerList.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__